import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import {PersonOutlined as PersonOutlinedIcon} from "@mui/icons-material";

const EmployeeProfile = () => {
  return (
    <Box
      sx={{
        p: 3,
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <Typography variant="h4" fontWeight={700} gutterBottom>
        My Profile
      </Typography>

      {/* Profile Card */}
      <Card sx={{ p: 2, mb: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3,
          }}
        >         
          <PersonOutlinedIcon sx={{ width: 100, height: 100 }}/>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              New Employee
            </Typography>
            <Typography color="text.secondary">Sales Manager</Typography>
          </Box>
        </Box>
      </Card>

      {/* User Details Form */}
      <Card>
        <CardContent>
          <Typography variant="h6" fontWeight={600} mb={2}>
            Personal Information
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Full Name" defaultValue="New Employee" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Email Address" defaultValue="employee@example.com" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Phone Number" defaultValue="123-456-7890" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Role" defaultValue="Sales Manager" />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                defaultValue="123 Main St, Bangalore"
              />
            </Grid>
          </Grid>

          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
          >
            Save Changes
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EmployeeProfile;
